import {
  FETCH_PARAMETER_REQUEST,
  FETCH_PARAMETER_SUCCESS,
  FETCH_PARAMETER_ERROR,
  UPDATE_PARAMETER_REQUEST,
  UPDATE_PARAMETER_SUCCESS,
  UPDATE_PARAMETER_ERROR,
  RESET_PARAMETERS,
  RESET_EDIT_PARAMETER,
  GET_PARAMETER_FROM_LIST,
  UPDATE_PARAMETER_FILTER,
  FETCH_CURRENT_BASE_SUCCESS,
  FETCH_CURRENT_BASE_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    filter: {
      dsKey: '',
      dsValue: '',
      idBranch: null,
      hasPagination: true,
      page: 1,
    },
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PARAMETER_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_PARAMETER_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
          filter: action.filter,
        },
      }

    case FETCH_PARAMETER_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
          filter: action.filter,
        },
      }

    case UPDATE_PARAMETER_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_PARAMETER_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
        },
      }

    case UPDATE_PARAMETER_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
        },
      }

    case RESET_PARAMETERS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: null,
        },
      }

    case RESET_EDIT_PARAMETER:
      return {
        ...state,
        edit: {
          isUpdating: false,
          error: null,
          record: {},
        },
      }

    case UPDATE_PARAMETER_FILTER:
      return {
        ...state,
        list: {
          ...state.list,
          filter: action.filter,
        },
      }

    case GET_PARAMETER_FROM_LIST:
      const { index } = action
      const record = state.list.records[index]

      return {
        ...state,
        get: {
          ...state.get,
          record,
          error: null,
          isFetching: false,
        },
      }

    case FETCH_CURRENT_BASE_SUCCESS:
      return {
        ...state,
        currentBase: action.payload,
      }

    case FETCH_CURRENT_BASE_ERROR:
      return {
        ...state,
        currentBase: null,
      }

    default:
      return state
  }
}

export default record
